import {
  WorkspaceSliceType,
  WorkspaceStateType,
} from 'types/store/workspaceStore';
import { type StateCreator, create } from 'zustand';

const NULL_INITIAL_STORE_VALUES: WorkspaceStateType = {
  currentWorkspaceID: undefined,
  workspace: undefined,
};

const workspaceSlice: StateCreator<WorkspaceSliceType> = (
  setState,
  getState,
  store
) => ({
  ...NULL_INITIAL_STORE_VALUES,

  // setWorkspaceID: (workspaceId: string) =>
  //   setState((state) => ({ ...state, currentWorkspaceID: workspaceId })),

  setWorkspace: (workspace) =>
    setState((state) => ({
      ...state,
      workspace,
      currentWorkspaceID: workspace.id,
    })),

  resetWorkspace: () =>
    setState((state) => ({ ...state, ...NULL_INITIAL_STORE_VALUES })),
});

export const useWorkspaceStore = create<WorkspaceSliceType>(
  (set, get, state) => ({ ...workspaceSlice(set, get, state) })
);
